import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SafePipe} from "./pipes/safe.pipe";
import {IndianNumberPipe} from "./pipes/indian-number.pipe";
import {NumberOnlyDirective} from "./directives/number-only.directive";
import { FilePreviewPipe } from './pipes/file-preview.pipe';
import {CamelCasePipe} from "./pipes/camel-case.pipe";

@NgModule({
  declarations: [
    SafePipe,
    IndianNumberPipe,
    NumberOnlyDirective,
    FilePreviewPipe,
    CamelCasePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SafePipe,
    IndianNumberPipe,
    FilePreviewPipe,
    NumberOnlyDirective,
    CamelCasePipe
  ]
})
export class SharedModule {
}
